import { apiRequest } from '@/Groups/Polymarket/private/imports/externalUtils';

const BASE = '/api/polymarket';

//Получить трейды с фильтрами
export const apiGetTrades = (params = {}, signal = null) => {
  const { page = 1, customUrl = null, ...filters } = params;
  
  if (customUrl) return apiRequest(customUrl, { signal });

  const searchParams = new URLSearchParams({ page });
  Object.entries(filters).forEach(([key, value]) => {
    if (value) searchParams.append(key, value === true ? 'True' : value);
  });
  return apiRequest(`/api/polymarket/trades/?${searchParams.toString()}`, { signal });
};

//Получить следующую страницу пагинации
export const apiGetNextPage = (url, signal) =>
  apiRequest(url, { signal });

//Поиск трейдов
export const apiSearchTrades = (query) =>
  apiRequest(`${BASE}/trades/search/?q=${encodeURIComponent(query)}`);

//Получить избранные трейды
export const apiGetTradesBookmarks = () =>
  apiRequest(`${BASE}/trades/bookmark/`);

//Добавить / убрать из избранного (переиспользуем reactionsApi если нужно)
export const apiToggleTradeBookmark = (objectId, contentType) =>
  apiRequest('/api/reactions/bookmarks/create/', {
    method: 'POST',
    body: JSON.stringify({ object_id: objectId, content_type: contentType }),
  });